import React, { FunctionComponent, useState, useRef } from "react";
import BakeryTable from "./BakeryTable";
import { getArea, getTimeStamp } from "./functions";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BakeryItem } from "./../types";

interface HeaderProps {
  isAllUnitsZero: boolean;
  isProcessing: boolean;
  isProcessingError: boolean;
  isFOH: boolean;
  submitButtonText: string;
  resetBakeTable: () => void;
  onSubmit: () => void;
  bakeTableState: BakeryItem[];
  setBakeTableState: React.Dispatch<React.SetStateAction<BakeryItem[]>>;
  storeName: string;
  storeId: number;
  storeTrial: boolean;
  tempCheckTrial: boolean;
  handleShowFeedback: (
    productName: string,
    PLU: string,
    plannerHour: string,
    quantity: number,
    made: number
  ) => void;
  clearTempChecks: (number | null)[];
}

const Header: FunctionComponent<HeaderProps> = ({
  isAllUnitsZero,
  resetBakeTable,
  onSubmit,
  bakeTableState,
  setBakeTableState,
  isProcessing,
  isProcessingError,
  isFOH,
  submitButtonText,
  storeName,
  storeId,
  storeTrial,
  tempCheckTrial,
  handleShowFeedback,
  clearTempChecks
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: { target: { value: string } }) => {
    setSearchQuery(event.target.value);
    window.dataLayer.push({
      event: "Search",
      bakery: storeName,
      bakery_area: getArea(isFOH),
      value: event.target.value,
      time: getTimeStamp()
    });
  };

  const handleClear = () => {
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    window.dataLayer.push({
      event: "Clear search field",
      bakery: storeName,
      bakery_area: getArea(isFOH),
      value: "(empty)",
      time: getTimeStamp()
    });
  };

  return (
    <header className="App-header">
      <div className="header-bar">
        <div className="search-container hlpr-relative">
          <input
            type="text"
            placeholder="Search (name or category)"
            ref={inputRef}
            onChange={handleChange}
            className="search-input hlpr-input hlpr-input--with-clear jr-search-input"
          ></input>
          <FontAwesomeIcon
            icon={faCircleXmark}
            className="hlpr-clear-input clear-search jr-clear-search"
            onClick={handleClear}
          />
        </div>
        <div className="buttons-container">
          <button
            className={`submit-button jr-reset ${
              isAllUnitsZero || isProcessing
                ? "grey-button button--secondary"
                : "button--secondary"
            }`}
            onClick={resetBakeTable}
            disabled={isAllUnitsZero || isProcessing}
          >
            Reset
          </button>
          <button
            className={`submit-button submit-button--send jr-send ${
              isAllUnitsZero || isProcessing || isProcessingError
                ? "grey-button"
                : ""
            }`}
            onClick={onSubmit}
            disabled={isAllUnitsZero || isProcessing || isProcessingError}
          >
            {isProcessing ? (
              <div className="loading-overlay__spinner hidden">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  className="spinner"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    className="path"
                    fill="none"
                    strokeWidth="6"
                    cx="33"
                    cy="33"
                    r="30"
                  ></circle>
                </svg>
              </div>
            ) : (
              submitButtonText
            )}
          </button>
        </div>
      </div>
      <div className="scroll-table">
        <BakeryTable
          searchQueryState={searchQuery}
          bakeTableState={bakeTableState}
          setBakeTableState={setBakeTableState}
          isFOH={isFOH}
          storeName={storeName}
          storeId={storeId}
          storeTrial={storeTrial}
          tempCheckTrial={tempCheckTrial}
          handleShowFeedback={handleShowFeedback}
          clearTempChecks={clearTempChecks}
        />
      </div>
    </header>
  );
};

export default Header;
